export const SUPPORTED_GAMES = ['poker', 'shan9mee'];

export const getEnabledGameCount = feature => SUPPORTED_GAMES.reduce((count, game) => {
    const access = feature(game, 'game');
    return count + (access.show && access.enabled ? 1 : 0);
}, 0);
